import createInterruptLogger from "./interrupt";
import createRecorderLogger from "./recorder";
import createLiveLogger from "./live";
import createLimiterLogger from "./limiter";
export default function createProctoringSessionLogger(baseLog) {
    const log = (input) => baseLog({ ...input, type: `session:${input.type}` });
    return {
        started(details) {
            return log({
                type: "started",
                details,
            });
        },
        finished(taskId, proctoringSessionId) {
            return log({
                type: "finished",
                details: { taskId, proctoringSessionId },
            });
        },
        interrupt: createInterruptLogger(log),
        recorder: createRecorderLogger(log),
        limiter: createLimiterLogger(log),
        live: createLiveLogger(log),
    };
}
